import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { PostHogProvider } from '@posthog/react';
import './index.css';
import { initSentry } from './lib/sentry.js';
import { initPostHog, posthog } from './lib/posthog.js';
import { App } from './App.js';
import { AdminApp } from './admin/AdminApp.js';

initSentry();
initPostHog();

const isAdminRoute = window.location.pathname.startsWith('/admin');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
          <p>Something went wrong. Please reload the page.</p>
        </div>
      }
    >
      <PostHogProvider client={posthog}>
        {isAdminRoute ? <AdminApp /> : <App />}
      </PostHogProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
